import { cn } from '../../lib/cn';

export function SegmentedMeter({
  ariaLabel,
  colorClassName = 'bg-teal-600',
  ratio,
  segmentCount = 16,
}: {
  ariaLabel: string;
  colorClassName?: string;
  ratio: number;
  segmentCount?: number;
}) {
  const filledSegments = Math.max(0, Math.min(1, ratio)) * segmentCount;

  return (
    <div
      aria-label={ariaLabel}
      className="grid gap-[3px]"
      role="img"
      style={{ gridTemplateColumns: `repeat(${segmentCount}, minmax(0, 1fr))` }}
    >
      {Array.from({ length: segmentCount }, (_, index) => {
        const segmentFill = Math.max(0, Math.min(1, filledSegments - index));
        return (
          <span className="h-3.5 overflow-hidden rounded-[4px] border border-slate-200 bg-slate-100" key={index}>
            <span aria-hidden="true" className={cn('block h-full', colorClassName)} style={{ width: `${segmentFill * 100}%` }} />
          </span>
        );
      })}
    </div>
  );
}
